import { FC } from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getEmployees } from 'api/about'
import About from 'features/about/About'
import { AboutProps } from 'features/about/types'
import Layout from 'components/layout/Layout'

const AboutPage: FC<AboutProps> = (props) => {
  return (
    <Layout>
      <About {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  let employees = []

  try {
    employees = await getEmployees(locale)
  } catch (e) {
    throw new Error(e)
  }

  return {
    props: {
      employees,
      ...(await serverSideTranslations(locale))
    }
  }
}

export default AboutPage
